import {Tooltip} from "@nextui-org/react";

export const NeoTripFailureReason: React.FC<any> = ({data, uid}) => {
  const value = data?.[uid];
  if (!value) return <span>-</span>;
  return (
    <Tooltip content={value}>
      <p className="max-w-[220px] truncate">{value}</p>
    </Tooltip>
  );
};
